import { Routes } from '@angular/router';
import { MapComponent } from './map/map.component';
import { authGuardFn } from './auth/auth.guard';
import { adminGuardFn } from './auth/admin.guard';
import { homeGuardFn } from './auth/home.guard';
import { gdprGuardFn } from './auth/gdpr.guard';

export const routes: Routes = [
  { path: '', canActivate: [homeGuardFn], children: [] },
  {
    path: 'admin',
    title: 'Administrare',
    loadComponent: () => import('./admin/admin-root.component').then((m) => m.AdminRootComponent),
    canActivate: [authGuardFn, gdprGuardFn, adminGuardFn],
    children: [
        { path: '', redirectTo: 'users', pathMatch: 'full' },
        {
            path: 'sources',
            loadComponent: () => import('./admin/source-management.component').then((m) => m.SourceManagementComponent)
        },
        {
            path: 'taxonomy',
            loadComponent: () => import('./admin/taxonomy-manager.component').then((m) => m.TaxonomyManagerComponent)
        },
        {
            path: 'merge-species',
            loadComponent: () => import('./admin/merge-species.component').then((m) => m.MergeSpeciesComponent)
        },
        {
            path: 'users',
            loadComponent: () => import('./admin/user-management.component').then((m) => m.UserManagementComponent)
        },
        {
            path: 'equipment',
            loadComponent: () => import('./equipment/equipment-list.component').then((m) => m.EquipmentListComponent)
        },
        {
            path: 'equipment/new',
            loadComponent: () => import('./equipment/equipment-form.component').then((m) => m.EquipmentFormComponent)
        },
        {
            path: 'equipment/:id/edit',
            loadComponent: () => import('./equipment/equipment-form.component').then((m) => m.EquipmentFormComponent)
        },
        {
            path: 'sessions',
            loadComponent: () => import('./equipment/session-list.component').then((m) => m.SessionListComponent)
        },
        {
            path: 'sessions/new',
            loadComponent: () => import('./equipment/session-form.component').then((m) => m.SessionFormComponent)
        },
        {
            path: 'sessions/:id',
            loadComponent: () => import('./equipment/session-detail.component').then((m) => m.SessionDetailComponent)
        },
        {
            path: 'events',
            loadComponent: () => import('./events/event-list.component').then((m) => m.EventListComponent)
        },
        {
            path: 'events/new',
            loadComponent: () => import('./events/event-form.component').then((m) => m.EventFormComponent)
        },
        {
            path: 'events/:id/edit',
            loadComponent: () => import('./events/event-form.component').then((m) => m.EventFormComponent)
        },
        {
            path: 'events/:id/invitations',
            loadComponent: () => import('./events/event-invitations.component').then((m) => m.EventInvitationsComponent)
        }
    ]
  },
  {
    path: 'map',
    title: 'Harta',
    loadComponent: () => import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'observations',
    title: 'Observații',
    loadComponent: () => import('./observations/observations.component').then((m) => m.ObservationsComponent),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'observations/new',
    title: 'Observație Nouă',
    loadComponent: () =>
      import('./observations/create-observation/create-observation.component').then(
        (m) => m.CreateObservationComponent
      ),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'observations/edit/:id',
    title: 'Editează Observație',
    loadComponent: () =>
      import('./observations/create-observation/create-observation.component').then(
        (m) => m.CreateObservationComponent
      ),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'observations/:id',
    title: 'Detalii Observație',
    loadComponent: () =>
      import('./observations/detail-observation/detail-observation.component').then(
        (m) => m.DetailObservationComponent
      ),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'observations/verify/:id',
    title: 'Verificare Observație',
    loadComponent: () =>
      import('./observations/verify-observation/verify-observation.component').then(
        (m) => m.VerifyObservationComponent
      ),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'garbage',
    title: 'Rapoarte Deșeuri',
    loadComponent: () => import('./garbage/garbage-list/garbage-list.component').then((m) => m.GarbageListComponent),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'garbage/new',
    title: 'Raport Deșeuri Nou',
    loadComponent: () =>
      import('./garbage/create-garbage/create-garbage.component').then((m) => m.CreateGarbageComponent),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'garbage/:id/edit',
    title: 'Editează Raport Deșeuri',
    loadComponent: () =>
      import('./garbage/create-garbage/create-garbage.component').then((m) => m.CreateGarbageComponent),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'garbage/:id',
    title: 'Detalii Raport Deșeuri',
    loadComponent: () =>
      import('./garbage/garbage-detail/garbage-detail.component').then((m) => m.GarbageDetailComponent),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'atlas',
    title: 'Atlas Viețuitoare',
    loadComponent: () => import('./atlas/living-things-list/living-things-list.component').then((m) => m.LivingThingsListComponent),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'atlas/tree',
    title: 'Taxonomie Viețuitoare',
    loadComponent: () => import('./atlas/living-things-tree/living-things-tree.component').then((m) => m.LivingThingsTreeViewComponent),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'atlas/:id',
    title: 'Detalii Viețuitoare',
    loadComponent: () => import('./atlas/living-thing-detail/living-thing-detail.component').then((m) => m.LivingThingDetailComponent),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'observations/join/:token',
    title: 'Acceptă invitația',
    loadComponent: () =>
      import('./observations/join-observation/join-observation.component').then(
        (m) => m.JoinObservationComponent
      ),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'events',
    title: 'Evenimente',
    loadComponent: () => import('./events/events-hub.component').then((m) => m.EventsHubComponent),
    canActivate: [authGuardFn, gdprGuardFn],
    children: [
      { path: '', redirectTo: 'my', pathMatch: 'full' },
      {
        path: 'my',
        loadComponent: () => import('./events/my-events.component').then((m) => m.MyEventsComponent),
      },
      {
        path: 'open',
        loadComponent: () => import('./events/open-events.component').then((m) => m.OpenEventsComponent),
      },
      {
        path: 'manage',
        loadComponent: () => import('./events/event-list.component').then((m) => m.EventListComponent),
      },
      {
        path: 'manage/new',
        loadComponent: () => import('./events/event-form.component').then((m) => m.EventFormComponent),
      },
      {
        path: 'manage/:id/edit',
        loadComponent: () => import('./events/event-form.component').then((m) => m.EventFormComponent),
      },
      {
        path: 'manage/:id/invitations',
        loadComponent: () => import('./events/event-invitations.component').then((m) => m.EventInvitationsComponent),
      },
    ],
  },
  {
    path: 'events/:id/view',
    title: 'Detalii Eveniment',
    loadComponent: () => import('./events/event-participant-detail.component').then((m) => m.EventParticipantDetailComponent),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'harta',
    title: 'Hartă Publică',
    loadComponent: () => import('./public-map/public-map.component').then((m) => m.PublicMapComponent),
  },
  {
    path: 'auth',
    loadComponent: () => import('./auth/auth.component').then((m) => m.AuthComponent),
  },
  {
    path: 'auth/orgo-callback',
    title: 'Autentificare Orgo',
    loadComponent: () =>
      import('./auth/orgo-callback/orgo-callback.component').then(
        (m) => m.OrgoCallbackComponent
      ),
  },
  {
    path: 'expert-application',
    title: 'Aplica ca expert',
    loadComponent: () =>
      import('./expert-application/expert-application.component').then(
        (m) => m.ExpertApplicationComponent
      ),
  },
  {
    path: 'magic-link',
    title: 'Autentificare cu link magic',
    loadComponent: () =>
      import('./auth/magic-link-request/magic-link-request.component').then(
        (m) => m.MagicLinkRequestComponent
      ),
  },
  {
    path: 'magic-login/:token',
    title: 'Autentificare',
    loadComponent: () =>
      import('./auth/magic-link-verify/magic-link-verify.component').then(
        (m) => m.MagicLinkVerifyComponent
      ),
  },
  {
    path: 'forgot-password',
    title: 'Resetare parolă',
    loadComponent: () =>
      import('./auth/password-reset-request/password-reset-request.component').then(
        (m) => m.PasswordResetRequestComponent
      ),
  },
  {
    path: 'reset-password/:uid/:token',
    title: 'Setare parolă nouă',
    loadComponent: () =>
      import('./auth/password-reset-confirm/password-reset-confirm.component').then(
        (m) => m.PasswordResetConfirmComponent
      ),
  },
  {
    path: 'account-setup/:token',
    title: 'Configurare cont',
    loadComponent: () =>
      import('./auth/account-setup/account-setup.component').then(
        (m) => m.AccountSetupComponent
      ),
  },
  {
    path: 'despre',
    title: 'Despre FaunaGo',
    loadComponent: () => import('./about/about.component').then((m) => m.AboutComponent),
  },
  {
    path: 'termeni',
    title: 'Termeni și Condiții',
    loadComponent: () => import('./legal/terms.component').then((m) => m.TermsComponent),
  },
  {
    path: 'confidentialitate',
    title: 'Politica de Confidențialitate',
    loadComponent: () => import('./legal/privacy.component').then((m) => m.PrivacyComponent),
  },
  {
    path: 'notifications',
    title: 'Notificări',
    loadComponent: () =>
      import('./notifications/notifications.component').then((m) => m.NotificationsComponent),
    canActivate: [authGuardFn, gdprGuardFn],
  },
  {
    path: 'profile',
    title: 'Profil Utilizator',
    loadComponent: () => import('./profile/profile.component').then((m) => m.ProfileComponent),
    canActivate: [authGuardFn],
    // NOTE: no gdprGuardFn here — profile is where users give consent
  },
  {
    path: '**',
    loadComponent: () => import('./page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent),
  },
];
